import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/vendors/login/Page";

export const PATH = "/vendors/login";

function Login() {
	return (
		<>
			<NskHead title="TOP" />
			<Component />
		</>
	);
}

export default Login;
